import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import ActiveMeeting from "./ActiveMeeting";
import InactiveMeeting from "./InactiveMeeting";
import AdminLoader from "../AdminLoader";
import MWPageTitle from "../../component/MWPageTitle";
import PageLayout from "../Layout/PageLayout";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ mt: 1 }}>{children}</Box>}
    </Box>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TeleHealth() {
  const loadingMarkup = <AdminLoader />;
  const [selected, setSelected] = useState(0);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelected(newValue);
  };
  const [activemeetingLoader, setActivemeetingLoader] = useState(false);
  const [inactivemeetingLoader, setInactivemeetingLoader] = useState(false);

  const pageMarkUp = (
    <Box>
      <Tabs value={selected} onChange={handleTabChange}>
        <Tab label="Active Meeting" {...a11yProps(0)} />
        <Tab label="Inactive Meeting" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={selected} index={0}>
        {<ActiveMeeting activemeetingLoader={setActivemeetingLoader} />}
      </TabPanel>
      <TabPanel value={selected} index={1}>
        {<InactiveMeeting inactivemeetingLoader={setInactivemeetingLoader} />}
      </TabPanel>
    </Box>
  );

  return (
    <Box>
      {activemeetingLoader || inactivemeetingLoader ? loadingMarkup : null}
      <PageLayout>
        <MWPageTitle title="Telehealth" />
        {pageMarkUp}
      </PageLayout>
    </Box>
  );
}
